import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class TemplateService {

  constructor(private http: HttpClient) {
  }

  getTemplateList(typeId) {
    return this.http.get<any[]>('api/a/template/list/by/type/' + typeId);
  }

  getTemplateParamListByType(typeId) {
    return this.http.get<any[]>('api/a/template/params/list/by/type/' + typeId);
  }

  createNewTemplate(dto) {
    return this.http.post<any>('api/a/template/create', dto);
  }

  saveTemplateWithFile(fd) {
    return this.http.post<any>('api/a/template/save/with/file', fd, {headers: {'noContentType': 'true'}});
  }

  deleteTemplateById(templateId) {
    return this.http.delete<any>('api/a/template/delete/' + templateId);
  }

  getTemplate(id) {
    return this.http.get<any[]>('api/a/template/get/by/id/' + id);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/shared/services/template.service.ts